<template>
  <div class="backgournd-box" id="prospects">
    <b-container >
      <b-row class="prospects-title">
        <b-col class="m-landing-h1-center">
          <h1 class="m-landing-h1">Reach New Prospects</h1>
          <p class="m-landing-h1-brief">Connect with your best prospects through privacy-compliant digital or traditional channels to win new customers. Do it yourself or work with a specialist.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col style="padding-left: 32px">
          <h3  class="m-landing-h3">Begin a digital campaign</h3>
          <p>Tell us your goals and and budget. Our experts will craft and manage a full-service campaign for you.</p>
          <b-btn variant="primary"
                 @click="showDigital"
                 class="digital-btn"
                 v-m-ua-event="['landing', 'datasource', 'Full Service Digital Campaigns']">
            Choose email</b-btn>
          <b-btn @click="showDigital"
                 class="digital-btn"
                 v-m-ua-event="['landing', 'datasource', 'Full Service Digital Campaigns']">
            Choose display & social</b-btn>
          <b-btn @click="showDigital"
                 class="digital-btn"
                 v-m-ua-event="['landing', 'datasource', 'Full Service Digital Campaigns']">
            Choose multi-channel</b-btn>

        </b-col>
        <b-col>
          <h3 class="m-landing-h3">Order Mailing Lists</h3>
          <p>Build, order and download a new list of prospects—in just minutes. Add phone numbers (where available) for follow-up.</p>
          <transition name="m-fade">
            <div class="btns-box" v-show="userDataSources.length > 0">
              <b-btn v-for="item in topBtns"
                     :key="item.ListType"
                     variant="primary"
                     class="order-btn"
                     v-text="item.Desc"
                     @click="go(item.ListType)"
                     v-m-ua-event="['landing', 'datasource', item.Desc]"/>
              <b-btn v-for="item in normalBtns"
                     :key="item.ListType"
                     v-text="item.Desc"
                     class="order-btn"
                     v-m-ua-event="['landing', 'datasource', item.Desc]"
                     @click="go(item.ListType)" />
            </div>
          </transition>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    data () {
      return {
      }
    },
    computed: {
      userDataSources () {
        return this.$store.state.user.userDataSources
      },
      topBtns () {
        let result = []
        for (let i = 0; i < this.userDataSources.length; i++) {
          let item = this.userDataSources[i]
          if (item.ListType === 10 || item.ListType === 170) {
            result.push(item)
          }
        }
        return result
      },
      normalBtns () {
        let result = []
        let isSaturation = false
        for (let i = 0; i < this.userDataSources.length; i++) {
          let item = this.userDataSources[i]
          if (item.ListType === 50) {
            isSaturation = true
          } else if (item.ListType !== 10 && item.ListType !== 170) {
            result.push(item)
          }
        }
        if (isSaturation) {
          for (let i = 0; i < this.userDataSources.length; i++) {
            let item = this.userDataSources[i]
            if (item.ListType === 50) {
              result.push(item)
            }
          }
        }
        return result
      }
    },
    methods: {
      go (listType) {
        this.$router.push({
          name: 'order',
          params: {
            listType: listType
          }
        })
      },
      showDigital () {
        this.$root.$emit('bv::show::modal', 'modelDigitalCampaigns')
      }
    }
  }
</script>

<style scoped lang="scss">
  .service-box {
    padding: 32px;
    background-color: $color-second;
    cursor: pointer;
    border-radius: 8px;
  }
  .service-box:hover {
    transform: scale(1.05);
  }
  .btns-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .backgournd-box {
    margin-top: 81px;
    padding-top: 81px;
    padding-bottom: 81px;
    background-color: #fff;
    min-height: 280px;
  }
  .order-btn {
    width: 155px;
    margin-bottom: 10px;
    display: block;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    margin-right: 24px;
  }
  .prospects-title {
    margin-bottom: 16px;
  }

  .digital-btn {
    display: block;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MSectionProspects.vue